import styles from "./FirstRunSun.module.css";

/**
 * The sun as a solar telescope shows it: a mottled disc, turning slowly, with
 * limb darkening and a thin glow. No rays or flares (owner, 2026-10-13). Size
 * it with `--sun-d` on a parent; `--sun-glow` sets the glow. Until `detailed`,
 * the disc is drawn without its surface, which is the costly part to paint.
 */
export function FirstRunSun({ detailed = true }: { detailed?: boolean }) {
  return (
    <div className={styles.sun} data-detailed={detailed || undefined}>
      <div className={styles.halo} />
      <div className={styles.disc}>
        <div className={styles.surface} />
        <div className={styles.shade} />
      </div>
    </div>
  );
}
